<template>
  <div>
    <Sticky>
      <nav class="app-navbar">
        <div class="nav-left">
          <button
            type="button"
            class="icon-btn"
            v-if="
              $route.path !== '/auth/login' &&
              $route.path !== '/home' &&
              $route.path !== '/'
            "
            @click="goBack"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <img class="nav-logo" src="/logo.png" alt="" @click="goHome" />
        </div>

        <div class="nav-right">
          <div
            class="balance-chip"
            v-if="$route.path !== '/auth/login' && authUser"
          >
            <img
              class="coin"
              src="data:image/png;base64,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"
              alt=""
            />
            <b>{{ Number($store.state.authUser.amount).toLocaleString() }}</b>
            <span>Unit</span>
          </div>

          <button
            type="button"
            class="hamburger-btn"
            aria-label="Menu"
            v-if="$route.path !== '/auth/login'"
            @click="toggleSideMenu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </Sticky>
    <SideMenu :visible="showSideMenu" @close="closeSideMenu" />
  </div>
</template>
<script>
import { Toast, Dialog, Sticky } from "vant";
import { mapActions } from "vuex";
import SideMenu from "./SideMenu.vue";

export default {
  components: { Sticky, SideMenu },
  data() {
    return {
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
      showSideMenu: false,
      isLoggingOut: false,
    };
  },
  watch: {
    $route() {
      this.closeSideMenu();
    },
    showSideMenu(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  methods: {
    ...mapActions(["logoutUser", "fetchUser"]),
    goBack() {
      this.$playSound();
      this.$router.go(-1);
    },
    goHome() {
      this.$playSound();
      this.$router.push("/home");
    },
    toggleSideMenu() {
      this.$playSound();
      this.showSideMenu = !this.showSideMenu;
    },
    closeSideMenu() {
      this.showSideMenu = false;
      document.body.style.overflow = "";
    },
    onOffMusic() {
      this.$store.commit("setMusic", !this.$store.state.music);
    },
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === "granted") {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === "en"
              ? "Notification permission granted!"
              : "အသိပေးချက်အတည်ပြုပြီးပြီ"
          );
        } else {
          alert(
            this.$store.state.language === "en"
              ? "Notification permission denied!"
              : "အသိပေးချက်အတည်ပြုမပြီးပြီ"
          );
        }
      });
    },
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        Toast.success(
          this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
        );
        this.$router.push("/welcome");
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
    closeNavCollapse() {
      $("#navbar-default").collapse("hide");
    },
    setLangLocalstorage(language) {
      localStorage.setItem("language", language);
      this.$store.commit("setLanguage", language);
      this.$i18n.locale = language;
      $("#navbar-default").collapse("hide");
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => {});
      $("#navbar-default").collapse("hide");
    },
    redirectRoute(path) {
      if (path === "2d") {
        this.$router.push("/user/2d");
      } else {
        this.$router.push("/user/3d");
      }
      return true;
    },
  },
  async mounted() {
    if (window.Notification.permission === "granted") {
      this.alreadyGranted = false;
    }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>
<style scoped>
.app-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 8px 12px;
  background: rgba(18, 18, 18, 0.94);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.nav-left,
.nav-right {
  display: flex;
  align-items: center;
}

.nav-logo {
  height: 36px;
  cursor: pointer;
}

.icon-btn {
  width: 34px;
  height: 34px;
  margin-right: 6px;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: #f3d26a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance-chip {
  display: flex;
  align-items: center;
  margin-right: 8px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(231, 181, 52, 0.12);
  border: 1px solid rgba(231, 181, 52, 0.16);
  color: #f7d56a;
}

.balance-chip b {
  font-size: 0.92rem;
  color: #fff;
}

.balance-chip span {
  margin-left: 4px;
  font-size: 0.72rem;
  color: #d8c48a;
}

.coin {
  height: 1.15rem;
  margin-right: 0.35rem;
  animation: flip-coin 2.5s linear infinite;
  transform-style: preserve-3d;
}

@keyframes flip-coin {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

.hamburger-btn {
  width: 38px;
  height: 38px;
  padding: 10px 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger-btn span {
  display: block;
  height: 2px;
  width: 100%;
  background: #f7d56a;
  border-radius: 2px;
}

.hamburger-btn:active {
  background: rgba(231, 181, 52, 0.16);
}
</style>
